(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["am-collection-worlds"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('am-collection-worlds')) {
    class AmCollectionWorlds extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-am-world-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-am-world-panel]'));
        if (!this.tabs.length || !this.panels.length) return;
        this.dataset.enhanced = 'true';
        const initial = this.dataset.initialGroup;
        const initialTab = this.tabs.find((tab) => tab.dataset.amWorldTab === initial) || this.tabs[0];
        this.activate(initialTab, false);
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab, false));
          tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab));
        });
      }

      activate(tab, moveFocus) {
        const group = tab.dataset.amWorldTab;
        this.tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          const selected = panel.dataset.amWorldPanel === group;
          panel.dataset.active = String(selected);
          panel.hidden = !selected;
        });
        if (moveFocus) tab.focus();
      }

      handleKeydown(event, tab) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const current = this.tabs.indexOf(tab);
        let next = current;
        if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.activate(this.tabs[next], true);
      }
    }

    customElements.define('am-collection-worlds', AmCollectionWorlds);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-header"] && !Shopify.designMode) return;
  try {
    
  const headers = document.querySelectorAll('.am-header');
  headers.forEach((header) => {
    const button = header.querySelector('.am-header__menu-button');
    const menu = header.querySelector('.am-header__mobile');
    if (!button || !menu) return;
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      menu.hidden = expanded;
    });
  });

  // Cart events are emitted only after Shopify accepts an add or a quantity change.
  const cartLink = document.querySelector('.am-header__cart');
  if (cartLink) {
    const badge = cartLink.querySelector('.am-header__cart-count');
    let lastCount = Number(cartLink.dataset.cartCount) || 0;
    let requestId = 0;
    let toastTimeout;

    const renderCount = (count) => {
      lastCount = count;
      cartLink.dataset.cartCount = String(count);
      cartLink.setAttribute('aria-label', `${Theme.translations.cart}: ${count}`);
      if (badge) {
        badge.textContent = count > 99 ? '99+' : String(count);
        badge.hidden = count === 0;
      }
    };

    const refreshCount = async () => {
      const currentRequest = ++requestId;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return null;
        const cart = await response.json();
        if (currentRequest !== requestId || !Number.isFinite(cart.item_count)) return null;
        renderCount(cart.item_count);
        return cart.item_count;
      } catch (_) {
        return null;
      }
    };

    const showAdded = (quantity) => {
      let toast = document.querySelector('.am-cart-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'am-cart-toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        document.body.appendChild(toast);
      }
      toast.replaceChildren();
      const message = document.createElement('span');
      message.textContent = quantity === 1
        ? Theme.translations.items_added_to_cart_one
        : Theme.translations.items_added_to_cart_other.replace('__COUNT__', String(quantity));
      const link = document.createElement('a');
      link.href = cartLink.href;
      link.textContent = Theme.translations.view_cart;
      toast.append(message, link);
      toast.classList.add('am-cart-toast--visible');
      clearTimeout(toastTimeout);
      toastTimeout = setTimeout(() => toast.classList.remove('am-cart-toast--visible'), 4500);
    };

    document.addEventListener('cart:update', (event) => {
      if (event.detail?.data?.didError) return;
      const data = event.detail?.data;
      const serverCount = event.detail?.resource?.item_count;
      if (Number.isFinite(serverCount)) {
        ++requestId;
        renderCount(serverCount);
      } else if (data?.source === 'product-form-component') {
        refreshCount();
      } else if (Number.isFinite(data?.itemCount)) {
        ++requestId;
        renderCount(data.itemCount);
      } else {
        refreshCount();
      }
      if (data?.source === 'product-form-component') {
        showAdded(Number(data.itemCount) || 1);
      }
    });

    // A checkout or Apple Pay return may restore a cached page with an old badge.
    window.addEventListener('pageshow', refreshCount);
  }

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.am-header__dropdown[open]').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.am-header__dropdown[open]').forEach((dropdown) => {
      const summary = dropdown.querySelector('summary');
      dropdown.removeAttribute('open');
      summary?.focus();
    });

    document.querySelectorAll('.am-header').forEach((header) => {
      const button = header.querySelector('.am-header__menu-button');
      const menu = header.querySelector('.am-header__mobile');
      if (!button || !menu || menu.hidden) return;
      button.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
      button.focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-home-hero"] && !Shopify.designMode) return;
  try {
    
  const initAussiesMateHero = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const slides = Array.from(root.querySelectorAll('[data-am-hero-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-am-hero-dot]'));
    const previous = root.querySelector('[data-am-hero-previous]');
    const next = root.querySelector('[data-am-hero-next]');
    const toggle = root.querySelector('[data-am-hero-toggle]');
    const status = root.querySelector('[data-am-hero-status]');
    const pauseIcon = root.querySelector('[data-am-hero-pause-icon]');
    const playIcon = root.querySelector('[data-am-hero-play-icon]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayAllowed = root.dataset.autoplay === 'true' && !reducedMotion;
    const interval = Math.max(Number(root.dataset.interval) || 7000, 5000);
    let activeIndex = 0;
    let timer;
    let paused = !autoplayAllowed;
    let pointerStart;

    if (slides.length < 2) return;

    const updateToggle = () => {
      if (!toggle) return;
      toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      if (pauseIcon) pauseIcon.hidden = paused;
      if (playIcon) playIcon.hidden = !paused;
    };

    const stopTimer = () => {
      if (timer) window.clearInterval(timer);
      timer = undefined;
    };

    const startTimer = () => {
      stopTimer();
      if (!paused) {
        timer = window.setInterval(() => showSlide(activeIndex + 1, false), interval);
      }
    };

    const showSlide = (requestedIndex, restartTimer = true) => {
      activeIndex = (requestedIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        slide.hidden = index !== activeIndex;
      });
      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
      if (status) {
        status.textContent = dots[activeIndex]?.getAttribute('aria-label') || '';
      }
      if (restartTimer) startTimer();
    };

    previous?.addEventListener('click', () => showSlide(activeIndex - 1));
    next?.addEventListener('click', () => showSlide(activeIndex + 1));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => showSlide(Number(dot.dataset.slideIndex)));
    });

    toggle?.addEventListener('click', () => {
      paused = !paused;
      updateToggle();
      startTimer();
    });

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
      if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
    });

    root.addEventListener('pointerdown', (event) => {
      pointerStart = event.clientX;
    });

    root.addEventListener('pointerup', (event) => {
      if (typeof pointerStart !== 'number') return;
      const distance = event.clientX - pointerStart;
      pointerStart = undefined;
      if (Math.abs(distance) < 55) return;
      showSlide(distance > 0 ? activeIndex - 1 : activeIndex + 1);
    });

    root.addEventListener('mouseenter', stopTimer);
    root.addEventListener('mouseleave', startTimer);
    root.addEventListener('focusin', stopTimer);
    root.addEventListener('focusout', startTimer);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopTimer();
      else startTimer();
    });

    updateToggle();
    startTimer();
  };

  document.querySelectorAll('[data-am-hero-slider]').forEach(initAussiesMateHero);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-am-hero-slider]').forEach(initAussiesMateHero);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-match-finder"] && !Shopify.designMode) return;
  try {
    
  const initMateFinder = (form) => {
    if (form.dataset.ready === 'true') return;
    form.dataset.ready = 'true';

    const result = form.querySelector('[data-finder-result]');
    const summary = form.querySelector('[data-finder-summary]');
    const resultLink = form.querySelector('[data-finder-result-link]');
    const clearButton = form.querySelector('[data-finder-clear]');
    const storageKey = `aussies-mate-match-${form.closest('.shopify-section')?.id || 'home'}`;

    const reveal = () => {
      const goal = form.querySelector('input[name="goal"]:checked');
      if (!goal) return;
      summary.textContent = `${form.dataset.resultPrefix} ${goal.dataset.result}`;
      resultLink.href = goal.dataset.url || '/collections/all';
      resultLink.textContent = form.dataset.resultLinkLabel;
      result.hidden = false;
      result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const values = Object.fromEntries(new FormData(form).entries());
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(values));
      } catch {
        // The finder still works when session storage is unavailable.
      }
      reveal();
    });

    clearButton.addEventListener('click', () => {
      form.reset();
      result.hidden = true;
      try {
        sessionStorage.removeItem(storageKey);
      } catch {
        // No action is needed when session storage is unavailable.
      }
      form.querySelector('input')?.focus();
    });

    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
      Object.entries(saved).forEach(([name, value]) => {
        const input = form.querySelector(`input[name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`);
        if (input) input.checked = true;
      });
    } catch {
      try {
        sessionStorage.removeItem(storageKey);
      } catch {
        // No action is needed when session storage is unavailable.
      }
    }
  };

  document.querySelectorAll('[data-am-finder]').forEach(initMateFinder);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-am-finder]').forEach(initMateFinder);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-policy-page"]) return;
  try {
    
  class PolicyGuide extends HTMLElement {
    connectedCallback() {
      const body = this.querySelector('[data-policy-body]');
      const toc = this.querySelector('[data-policy-toc]');
      const list = toc?.querySelector('ol');
      if (!body || !toc || !list) return;
      const headings = [...body.querySelectorAll('h2')];
      if (headings.length < 2) return;
      headings.forEach((heading, index) => {
        const id = heading.id || `policy-section-${index + 1}`;
        heading.id = id;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${id}`;
        link.textContent = heading.textContent;
        item.append(link);
        list.append(item);
      });
      toc.hidden = false;
    }
  }

  if (!customElements.get('policy-guide')) {
    customElements.define('policy-guide', PolicyGuide);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
